export default "__VITE_ASSET__Cg2GTn90__"